import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import CustomerHierarchy from "../../../containers/modules/master/customer-hierarchy";

export default function CustomerHierarchyRoute( props ) {
    const {authUser}=props
    return (
        <Route
            path="customer-hierarchy"
            index
            element={
                <AccessControl
                name={"Customer Hierarchy List"}
                auth={authUser}
                component={()=><CustomerHierarchy authUser={authUser} />}
                />
            }
        />
    )
}